import React from 'react';
import { useParams } from 'react-router-dom';

import CustomSegmentsForm from '../components/CustomSegments/CustomSegmentsForm';

function CustomSegmentsFormPage() {
  const {
    id
  } = useParams();

  return (
    <CustomSegmentsForm id={Number(id)} />
  );
}

export default CustomSegmentsFormPage;
